import React, { useState, useRef } from 'react';
import { IoChevronBackOutline, IoChevronForwardOutline } from 'react-icons/io5';

//comps
import CatalogOrderModal from './CatalogOrderModal';

import { PHOTO_BASE_URL } from 'utils/helpers';

const CatalogDetail = ({ product }) => {
	const photos = product.photos
		? product.photos
				.split(',')
				.map((p) => p.trim())
				.filter(Boolean)
		: [
				'https://placehold.co/600x480/FFFFFF/000000',
				'https://placehold.co/600x480/000000/FFFFFF',
				'https://placehold.co/600x480/FFFFFF/000000',
				'https://placehold.co/600x480/000000/FFFFFF',
			];

	const [activeIndex, setActiveIndex] = useState(0);
	const [showModalCanjear, setShowModalCanjear] = useState(false);
	const touchStartX = useRef(null);

	const handleTouchStart = (e) => {
		touchStartX.current = e.touches[0].clientX;
	};

	const handleTouchEnd = (e) => {
		if (touchStartX.current === null) return;
		const diff = touchStartX.current - e.changedTouches[0].clientX;
		if (Math.abs(diff) > 40) {
			if (diff > 0) setActiveIndex((activeIndex + 1) % photos.length);
			else setActiveIndex((activeIndex - 1 + photos.length) % photos.length);
		}
		touchStartX.current = null;
	};

	const points = product.points?.toLocaleString('es-ES');

	return (
		<>
			<div className="product-details">
				<div className="col-img">
					<div
						className="carousel-wrapper"
						onTouchStart={handleTouchStart}
						onTouchEnd={handleTouchEnd}
					>
						{photos.map((photo, i) => (
							<div
								key={i}
								className={`carousel-slide${i === activeIndex ? ' active' : ''}`}
							>
								<img src={`${PHOTO_BASE_URL}${photo}`} alt={`${product.name} ${i + 1}`} />
							</div>
						))}
						{photos.length > 1 && (
							<>
								<button
									className="carousel-arrow carousel-arrow--prev"
									onClick={() => setActiveIndex((activeIndex - 1 + photos.length) % photos.length)}
									aria-label="Foto anterior"
								>
									<IoChevronBackOutline />
								</button>
								<button
									className="carousel-arrow carousel-arrow--next"
									onClick={() => setActiveIndex((activeIndex + 1) % photos.length)}
									aria-label="Foto siguiente"
								>
									<IoChevronForwardOutline />
								</button>
							</>
						)}
					</div>
					{photos.length > 1 && (
						<div className="carousel-controls">
							{photos.map((_, i) => (
								<button
									key={i}
									className={activeIndex === i ? 'active' : ''}
									onClick={() => setActiveIndex(i)}
									aria-label={`Foto ${i + 1}`}
								/>
							))}
						</div>
					)}
				</div>

				<div className="col-info">
					<div className="title-prod">{product.name}</div>
					<div className="points-prod">{points} puntos</div>
					{product.stock > 0 ? (
						<button
							className="canjear-prod"
							onClick={() => setShowModalCanjear(true)}
						>
							CANJEAR PUNTOS
						</button>
					) : (
						<button className="canjear-prod disabled" disabled>
							AGOTADO
						</button>
					)}
					{product.description && (
						<div
							className="description-prod"
							dangerouslySetInnerHTML={{ __html: product.description }}
						/>
					)}
				</div>
			</div>

			{showModalCanjear && (
				<CatalogOrderModal
					toggle={() => setShowModalCanjear(false)}
					product={product}
				/>
			)}
		</>
	);
};

export default CatalogDetail;
